import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
var routes=[
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/login')
	},
	{
		path: '/cloud',
		name: 'cloud',
		component: () => import('@/views/cloud')
	},
	{
		path: '/login_auto',
		name: 'login_auto',
		component: () => import('@/views/login_auto')
	},
	{
		path: '/cockpit',
		name: '首页大屏',
		component: () => import('@/views/cockpit')
	},
	{
		path: '/cockpit_swiper',
		name: '视频和大屏轮播',
		component: () => import('@/views/cockpit_swiper')
	},
	{
		path: '/weiquan_swiper',
		name: '维权滚动',
		component: () => import('@/views/weiquan_swiper')
	},
	{
		path: '/workshop',
		name: '大屏',
		component: () => import('@/views/workshop')
	},
	{
		path: '/cockpit_early',
		name: '物资总控',
		component: () => import('@/views/cockpit_early')
	},
	{
		path: '/qcy_day_chat',
		name: '油罐大屏',
		component: () => import('@/views/warehouse/components/qcy_material_day_chat')
	},
	{
		path: '/external_large',
		name: '外接大屏',
		component: () => import('@/views/external_large')
	},
	{
		path: '/system_ceshi',
		component: () => import('@/views/system/ceshi'),
		name: ''
	},
	{
		path: '/personnel_dynamics_large',
		component: () => import('@/views/personnel/dynamics_large'),
		name: '人员大屏'
	},
	{
		path: '/warehouse_large',
		component: () => import('@/views/warehouse/large'),
		name: '仓储大屏'
	},
	{
		path: '/integrate_large',
		component: () => import('@/views/integrate/large'),
		name: '生产大屏'
	},
	{
		path: '/admin_large',
		component: () => import('@/views/admin_large'),
		name: '管理端大屏'
	},
	{
		path: '/',
		name: '',
		component: () => import('@/views/home'),
		children: [
			{
				path: 'index',
				component: () => import('@/views/index'),
				name: '首页'
			},
			{
				path: 'indexShenyang',
				component: () => import('@/views/indexShenyang'),
				name: '首页1'
			},
			{
				path: 'system_menu',
				component: () => import('@/views/system/menu'),
				name: '菜单'
			},
			{
				path: '/news_index',
				name: '系统消息',
				component: () => import('@/views/news/index')
			},
			{
				path: 'basics_datadictionary_list',
				component: () => import('@/views/basics/datadictionary_list'),
				name: '数据字典详情',
				cache:false,
			},
			{
				path: 'material_contract_purchase_info',
				component: () => import('@/views/material/contract_purchase_info'),
				name: '合同采购管理详情',
				cache:false,
			},
			{
				path: 'organize_position',
				component: () => import('@/views/organize/position'),
				name: '职位管理'
			},
			{
				path: 'organize_jobPosition',
				component: () => import('@/views/organize/jobPosition'),
				name: '工程部位'
			},
			{
				path: 'device_index_items',
				component: () => import('@/views/device/index_items'),
				name: '设备点检项详情'
			},
			{
				path: 'device_index_archives',
				component: () => import('@/views/device/index_archives'),
				name: '设备档案'
			},
			{
				path: 'material_index_archives',
				component: () => import('@/views/material/index_archives'),
				name: '配件档案'
			},
			{
				path: 'library_warehouse',
				component: () => import('@/views/library/warehouse'),
				name: '库管管理'
			},
			{
				path: 'library_goods_shelves',
				component: () => import('@/views/library/goods_shelves'),
				name: '库位管理'
			},
			{
				path: 'library_goods_shelves_ge',
				component: () => import('@/views/library/goods_shelves_ge'),
				name: '库格管理'
			},
			{
				path: 'consignment_shelves_number',
				component: () => import('@/views/consignment/shelves_number'),
				name: '库位管理1'
			},
			{
				path: 'consignment_shelves_ge',
				component: () => import('@/views/consignment/shelves_ge'),
				name: '库格管理1'
			},
			{
				path: 'workflow_info',
				component: () => import('@/views/workflow/info'),
				name: '工作流管理详情'
			}
		],
	},
	{
		path: '/',
		name: '风险安全排查1',
		component: () => import('@/views/secure'),
		children: [
			{
				path: 'secure_risk_check',
				component: () => import('@/views/secure/risk_check'),
				name: '风险安全排查-首页'
			},
		]
	}

	
]
export default routes;


// WEBPACK FOOTER //
// ./src/router/index.js